import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import PublicHeader from './PublicHeader';
import Footer from './Footer';
import TermsOfUseModal from '../modals/TermsOfUseModal';

const PublicLayout: React.FC = () => {
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);

  useEffect(() => {
    const handleOpenTermsModal = () => {
      setIsTermsModalOpen(true);
    };

    window.addEventListener('open-terms-modal', handleOpenTermsModal);

    return () => {
      window.removeEventListener('open-terms-modal', handleOpenTermsModal);
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PublicHeader />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      <TermsOfUseModal 
        isOpen={isTermsModalOpen} 
        onClose={() => setIsTermsModalOpen(false)} 
      />
    </div>
  );
};

export default PublicLayout;